import SiatPraticheSceltaListPage from "./pages/SiatPraticheSceltaListPage.vue";
import SiatPraticheAssegnateListPage from "./pages/SiatPraticheAssegnateListPage.vue";
import SiatPraticheListPage from "./pages/SiatPraticheListPage.vue"
import SiatPraticheEditPage from "./pages/SiatPraticheEditPage.vue"
import SiatRiepilogoPraticheListPage from "./pages/SiatRiepilogoPraticheListPage.vue";
import SiatNotificheListaPage from "./pages/SiatNotificheListaPage.vue"
export default {
	SiatPraticheSceltaListPage,
	SiatPraticheAssegnateListPage,
	SiatPraticheListPage,
	SiatPraticheEditPage,
	SiatNotificheListaPage,
	SiatRiepilogoPraticheListPage
};
